<template>
  <div class="dialog-contact">
    <el-button @click="dialogForm = true" :type="type" >{{btnName}}</el-button>

    <el-dialog
      :title="$t('dialogContact.TelephoneCounseling')"
      :visible.sync="dialogForm"
      width="300px"
    >
      <el-form ref="form" label-width="110px">
        <el-form-item :label="$t('dialogContact.HRphone')">
          <div>
            <a href="tel:+86 10 84831059">+86 10 84831159</a>
          </div>
        </el-form-item>
        <el-form-item :label="$t('dialogContact.DomesticTradePhone')">
          <div>
            <a href="tel:+86 10 8483 1799">+86 10 84833454</a>
          </div>
        </el-form-item>
        <el-form-item :label="$t('dialogContact.ForeignTradePhone')">
          <div>
            <a href="tel:+86 10 8483 3803">+86 10 8483243</a>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "dialogContact",
  data() {
    return {
      dialogForm: false
    };
  },
  props: {
    btnName: String,
    type: String,
  },
  components: {},
  methods: {},
  mounted() {
    var options = { live: false };
    new this.$wow.WOW(options).init();
  }
};
</script>

<style lang="scss" scoped>
.dialog-contact a {
  color: #0080ff;
}
.dialog-contact .el-form-item__content {
  text-align: left;
}
</style>
